import React from "react";
import PropTypes from "prop-types";

import Heading from "core/Heading";
import BodyText from "core/BodyText";
import colors from "core/colors";
import { OrderTotalContainer, OrderTotalContents, UsdBodyText } from "./styles";

const OrderTotal = ({ totalPrice }) => {
    return (
        <OrderTotalContainer>
            <OrderTotalContents data-testid="checkout-order-total">
                <BodyText type="p" size="sm" copyColor={colors.midnight}>
                    Charged today
                </BodyText>

                <Heading
                    type="p"
                    size="xs"
                    headingColor={colors.midnight}
                    alignment="right"
                >
                    <UsdBodyText type="span" size="sm" copyColor={colors.storm}>
                        USD
                    </UsdBodyText>
                    {totalPrice}
                </Heading>
            </OrderTotalContents>
        </OrderTotalContainer>
    );
};

OrderTotal.propTypes = {
    totalPrice: PropTypes.string.isRequired
};

export default OrderTotal;
